import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { X, Mail, Phone, User, MessageCircle, Send } from 'lucide-react';
import contactContent from "../content/contactform.json"

const ContactForm = ({ onClose, language }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    englishLevel: '',
    goals: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const t = contactContent[language];

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setLoading(true);

  //   // Simulate form submission
  //   setTimeout(() => {
  //     setLoading(false);
  //     setSubmitted(true);
  //   }, 1500);
  // };

  const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  const form = e.target;

  const formDataObj = new FormData(form);

  try {
    await fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams(formDataObj).toString(),
    });

    setSubmitted(true);
  } catch (error) {
    alert("Something went wrong. Please try again.");
    console.error(error);
  }

  setLoading(false);
};

  if (submitted) {
    return (
      <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          className="bg-white rounded-3xl max-w-md w-full p-8 text-center"
        >
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <Send className="w-8 h-8 text-green-600" />
          </div>
          <h2 className="text-2xl font-bold text-[#333] mb-2">{t.success.title}</h2>
          <p className="text-gray-600 mb-6">{t.success.subtitle}</p>
          <button
            onClick={onClose}
            className="w-full bg-blue-600 text-white py-3 rounded-lg hover:bg-blue-700 transition-colors"
          >
            {t.success.close}
          </button>
        </motion.div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="bg-white rounded-2xl max-w-2xl w-full max-h-[90vh] flex flex-col"
      >
        <div className="p-6 border-b border-gray-200 flex justify-between items-center">
          <div>
            <h2 className="text-2xl font-bold text-[#333]">{t.title}</h2>
            <p className="text-gray-600 mt-1">{t.subtitle}</p>
          </div>
          <button onClick={onClose} className="text-black hover:text-gray-700">
            <X className="w-6 h-6" />
          </button>
        </div>

        <form name="contact"
          method="POST"
          data-netlify="true" onSubmit={handleSubmit} className="p-6 space-y-6 overflow-y-auto">
          {/* Name Field */}
          <input type="hidden" name="form-name" value="contact" />
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              {t.fields.name} *
            </label>
            <div className="relative">
              <User className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                className="w-full pl-12 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                placeholder={language === 'es' ? 'Tu nombre completo' : 'Your full name'}
              />
            </div>
          </div>

          {/* Email Field */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              {t.fields.email} *
            </label>
            <div className="relative">
              <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full pl-12 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                placeholder={language === 'es' ? 'tu@email.com' : 'your@email.com'}
              />
            </div>
          </div>

          {/* Phone Field */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              {t.fields.phone}
            </label>
            <div className="relative">
              <Phone className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                className="w-full pl-12 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                placeholder={language === 'es' ? '+34 600 000 000' : '+34 600 000 000'}
              />
            </div>
          </div>

          {/* English Level */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              {t.fields.englishLevel} *
            </label>
            <select
              name="englishLevel"
              value={formData.englishLevel}
              onChange={handleChange}
              required
              className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
            >
              {t.levels.map((level) => (
                <option key={level.value} value={level.value}>
                  {level.label}
                </option>
              ))}
            </select>
          </div>

          {/* Goals */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              {t.fields.goals} *
            </label>
            <select
              name="goals"
              value={formData.goals}
              onChange={handleChange}
              required
              className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
            >
              {t.goalOptions.map((goal) => (
                <option key={goal.value} value={goal.value}>
                  {goal.label}
                </option>
              ))}
            </select>
          </div>

          {/* Additional Message */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              {t.fields.message}
            </label>
            <div className="relative">
              <MessageCircle className="absolute left-3 top-4 text-gray-400 w-5 h-5" />
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows={4}
                className="w-full pl-12 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                placeholder={language === 'es'
                  ? 'Cuéntanos más sobre tus objetivos específicos...'
                  : 'Tell us more about your specific goals...'
                }
              />
            </div>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-gradient-accent text-white py-3 rounded-lg font-semibold hover:scale-105 transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center space-x-2"
          >
            {loading ? (
              <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
            ) : (
              <>
                <Send className="w-4 h-4" />
                <span>{t.button}</span>
              </>
            )}
          </button>

          <p className="text-sm text-gray-500 text-center">
            {language === 'es'
              ? 'Nos pondremos en contacto contigo dentro de 24 horas'
              : 'We\'ll get in touch with you within 24 hours'
            }
          </p>
        </form>
      </motion.div>
    </div>
  );
};

export default ContactForm;